import Script from "next/script";

export default function Ad_320x50(props) {

  const isProduction = process.env.NODE_ENV === "production";

  return (
    <div className="Ad_300x100" id={props.id}>
      <div className="Horizon_auto">
         {/* Load Google AdSense Script */}
         {/* <Script
          id="Adsense-id"
          data-ad-client="ca-pub-2622226100196993"
          async="true"
          strategy="beforeInteractive"
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
        /> */}
        <ins
          className="adsbygoogle"
          style={{display:"inline-block",width:"320px",height:"50px"}}
          data-ad-client="ca-pub-2622226100196993"
          data-ad-slot="8977824082"
        ></ins>
          {isProduction&&<Script
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
         (adsbygoogle = window.adsbygoogle || []).push({});
              `,
          }}
        />}
      </div>
    </div>
  );
}
